module.exports = __webpack_public_path__ + "img/Beste.327ab634.jpg";